import { grayscale } from 'src/styles/colors'
import styled from 'styled-components'
import { device } from 'src/styles/breakpoints'

export const SummaryBox = styled.div`
  padding: 24px 24px;
  border: 1px solid ${grayscale[200]};
  border-radius: 12px;
  width: 100%;

  @media ${device.tablet} {
    padding: 32px 24px;
  }

  .sora {
    font-family: 'Sora', Helvetica, sans-serif;
  }
`
